import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { trackEvent } from "@/lib/analytics";

interface Faq { q: string; a: string }

export default function GameFaqSection({
  faqs,
  gameSlug,
  stateSlug,
  heading,
}: {
  faqs: Faq[];
  gameSlug: string;
  stateSlug?: string;
  heading: string;
}) {
  return (
    <section className="mt-10">
      <h2 className="font-sans text-[20px] font-bold mb-3 tracking-tight">{heading}</h2>
      <div className="grid gap-4 sm:grid-cols-2">
        {faqs.map((f, i) => (
          <Card
            key={f.q}
            onClick={() =>
              trackEvent("faq_open", {
                action: "faq_open",
                game_id: gameSlug,
                state_id: stateSlug,
                question_id: `q${i + 1}`,
                question: f.q,
              })
            }
          >
            <CardHeader className="pb-2"><CardTitle className="text-base">{f.q}</CardTitle></CardHeader>
            <CardContent><p className="text-sm text-muted-foreground">{f.a}</p></CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}